import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 20, height = 20, color = 'currentColor' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 20 20'>
  <path d='M9.9915 1.66663C5.3915 1.66663 1.6665 5.39996 1.6665 9.99996C1.6665 14.6 5.3915 18.3333 9.9915 18.3333C14.5998 18.3333 18.3332 14.6 18.3332 9.99996C18.3332 5.39996 14.5998 1.66663 9.9915 1.66663ZM9.99984 16.6666C6.3165 16.6666 3.33317 13.6833 3.33317 9.99996C3.33317 6.31663 6.3165 3.33329 9.99984 3.33329C13.6832 3.33329 16.6665 6.31663 16.6665 9.99996C16.6665 13.6833 13.6832 16.6666 9.99984 16.6666Z' fill={color} />
  <path d='M10.4165 5.83337H9.1665V10.8334L13.5415 13.4584L14.1665 12.4334L10.4165 10.2084V5.83337Z' fill={color} />
</svg>
